webpackJsonp([27,25],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vuexRouterSync = __webpack_require__(1080);
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _elementUi = __webpack_require__(685);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(180);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _Root = __webpack_require__(802);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexI18n = __webpack_require__(495);
	
	var _vuexI18n2 = _interopRequireDefault(_vuexI18n);
	
	var _lang = __webpack_require__(357);
	
	var _lang2 = _interopRequireDefault(_lang);
	
	var _validations = __webpack_require__(358);
	
	var _validations2 = _interopRequireDefault(_validations);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _veeValidate = __webpack_require__(81);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFroalaWysiwyg = __webpack_require__(799);
	
	var _vueFroalaWysiwyg2 = _interopRequireDefault(_vueFroalaWysiwyg);
	
	var _vueSelect = __webpack_require__(1077);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _vueJsToggleButton = __webpack_require__(801);
	
	var _vueJsToggleButton2 = _interopRequireDefault(_vueJsToggleButton);
	
	var _store = __webpack_require__(154);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(539);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _http = __webpack_require__(5);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _eventbus = __webpack_require__(536);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lang = 'en';
	
	__webpack_require__(535);
	
	__webpack_require__(533);
	__webpack_require__(534);
	
	_vue2.default.use(_http2.default, { store: _store2.default, router: _router2.default });
	
	window.baseUrl = _config.apiUrl;
	
	_vue2.default.use(_eventbus2.default);
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	var hf = new _vuex2.default.Store({
	  modules: {
	    i18n: _vuexI18n2.default.store
	  }
	});
	
	_vue2.default.use(_vueJsToggleButton2.default);
	_vue2.default.use(_vueFroalaWysiwyg2.default);
	
	_vue2.default.directive('focus', {
	  inserted: function inserted(el) {
	    el.focus();
	  }
	});
	
	var numeral = __webpack_require__(789);
	
	_vue2.default.filter("formatNumber", function (value) {
	  return numeral(value).format("0,0");
	});
	
	_vue2.default.use(_vuexI18n2.default.plugin, hf);
	_vue2.default.i18n.add('en', _lang2.default.en);
	
	_vue2.default.i18n.set(Lang);
	(0, _moment2.default)().locale(Lang);
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	_vue2.default.use(_veeValidate2.default, { locale: Lang, events: 'blur' });
	
	var infiniteScroll = __webpack_require__(800);
	_vue2.default.use(infiniteScroll);
	
	_vue2.default.config.lang = Lang;
	
	
	_vue2.default.component('v-select', _vueSelect2.default);
	
	var VueTruncate = __webpack_require__(1079);
	_vue2.default.use(VueTruncate);
	
	new _vue2.default({
	  store: _store2.default,
	  router: _router2.default,
	  el: '#app',
	  render: function render(h) {
	    return h(_Root2.default);
	  }
	});

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiUrl = exports.apiUrl = ("https://cyberlearning.doh.gov.ae/internal/v1");
	var version = exports.version = ("1.0.0");
	var cdnDomain = exports.cdnDomain = ("https://cyberlearningcdn.doh.gov.ae/");
	var termsLink = exports.termsLink = ({"NODE_ENV":"production","API_URL":"https://cyberlearning.doh.gov.ae/internal/v1","VERSION":"1.0.0","CDN_DOMAIN":"https://cyberlearningcdn.doh.gov.ae/","EDUCATION_URL":"https://cyberlearningeducate.doh.gov.ae/","REMEDIATOR_URL":"https://api.emailremediator.com/api/v1/office","APP_URL":"https://cyberlearningmgmt.doh.gov.ae"}).TERMS_LINK;
	var policyLink = exports.policyLink = ({"NODE_ENV":"production","API_URL":"https://cyberlearning.doh.gov.ae/internal/v1","VERSION":"1.0.0","CDN_DOMAIN":"https://cyberlearningcdn.doh.gov.ae/","EDUCATION_URL":"https://cyberlearningeducate.doh.gov.ae/","REMEDIATOR_URL":"https://api.emailremediator.com/api/v1/office","APP_URL":"https://cyberlearningmgmt.doh.gov.ae"}).POLICY_LINK;
	var educationLink = exports.educationLink = ("https://cyberlearningeducate.doh.gov.ae/");
	var remediatorLink = exports.remediatorLink = ("https://api.emailremediator.com/api/v1/office");
	var appUrl = exports.appUrl = ("https://cyberlearningmgmt.doh.gov.ae");
	
	var userTokenStorageKey = exports.userTokenStorageKey = 'APP_USER_TOKEN';

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.http = undefined;
	exports.setToken = setToken;
	exports.default = install;
	
	var _axios = __webpack_require__(37);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _interceptors = __webpack_require__(537);
	
	var _interceptors2 = _interopRequireDefault(_interceptors);
	
	var _config = __webpack_require__(4);
	
	var _localforage = __webpack_require__(132);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _lodash = __webpack_require__(7);
	
	var _config2 = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var http = exports.http = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	function setToken(token) {
	  http.defaults.headers.common.Authorization = 'Bearer ' + token;
	}
	
	function install(Vue, _ref) {
	  var store = _ref.store,
	      router = _ref.router;
	
	
	  (0, _interceptors2.default)(http, store, router);
	
	  Object.defineProperty(Vue.prototype, '$http', {
	    get: function get() {
	      return http;
	    }
	  });
	}

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getData = undefined;
	
	var _lodash = __webpack_require__(7);
	
	var getData = exports.getData = function getData(obj) {
	  return (0, _lodash.get)(obj, 'data');
	};

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.checkCompanyLicense = exports.revokeToken = exports.loadUserData = exports.postVerification = exports.postRegister = exports.postLearningLogin = exports.postByEmailLinkLogin = exports.postLogin = undefined;
	
	var _objectDestructuringEmpty2 = __webpack_require__(549);
	
	var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);
	
	var _http = __webpack_require__(5);
	
	var _get = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var postLogin = exports.postLogin = function postLogin(_ref) {
	  var email = _ref.email,
	      password = _ref.password;
	  return _http.http.post('/auth/login', { email: email, password: password }).then(_get.getData);
	};var postByEmailLinkLogin = exports.postByEmailLinkLogin = function postByEmailLinkLogin(_ref2) {
	  (0, _objectDestructuringEmpty3.default)(_ref2);
	  return _http.http.post('/auth/loginbyemail/'.target, {}).then(_get.getData);
	};var postLearningLogin = exports.postLearningLogin = function postLearningLogin(_ref3) {
	  var email = _ref3.email,
	      target = _ref3.target;
	  return _http.http.post('/auth/learning/login', { email: email, target: target }).then(_get.getData);
	};var postRegister = exports.postRegister = function postRegister(_ref4) {
	  var first_name = _ref4.first_name,
	      last_name = _ref4.last_name,
	      designation = _ref4.designation,
	      company = _ref4.company,
	      employee_count = _ref4.employee_count,
	      country = _ref4.country,
	      timezone = _ref4.timezone,
	      email = _ref4.email,
	      password = _ref4.password;
	  return _http.http.post('/auth/register', { first_name: first_name, last_name: last_name, designation: designation, company: company, employee_count: employee_count, country: country, timezone: timezone, email: email, password: password }).then(_get.getData);
	};var postVerification = exports.postVerification = function postVerification(_ref5) {
	  var id = _ref5.id,
	      token = _ref5.token,
	      secret = _ref5.secret;
	  return _http.http.post('/auth/verify', { id: id, token: token, secret: secret }).then(_get.getData);
	};
	
	var loadUserData = exports.loadUserData = function loadUserData() {
	  return _http.http.get('/me').then(_get.getData);
	};
	
	var revokeToken = exports.revokeToken = function revokeToken() {
	  return _http.http.post('/auth/token/revoke').then(_get.getData);
	};
	
	var checkCompanyLicense = exports.checkCompanyLicense = function checkCompanyLicense(token) {
	  return _http.http.post('/auth/validatelic', { 'token': token }).then(_get.getData);
	};

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_TOKEN = exports.SET_TOKEN = 'Auth//SET_TOKEN';
	var SET_USER = exports.SET_USER = 'Auth//SET_USER';

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(532);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});
	
	var _routes = __webpack_require__(528);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    success: '',
	    error: {},
	    warning: '',
	    validation: {}
	  },
	  fetching: false
	};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(498);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(501);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(505);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(508);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(509);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});
	
	var _vuex = __webpack_require__(512);
	
	Object.defineProperty(exports, 'vuex', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_vuex).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompanySubOrg = exports.deleteDomain = exports.verifyTxtRecord = exports.verifyNewDomain = exports.updateDomainData = exports.addNewDomain = exports.geteditDomains = exports.getDomains = undefined;
	
	var _http = __webpack_require__(5);
	
	var _get = __webpack_require__(10);
	
	var getDomains = exports.getDomains = function getDomains(id) {
	  return _http.http.get('/companies/domains/listing?company=' + id).then(_get.getData);
	};
	
	var geteditDomains = exports.geteditDomains = function geteditDomains(id) {
	  return _http.http.get('/companies/domains/edit/' + id).then(_get.getData);
	};
	
	var addNewDomain = exports.addNewDomain = function addNewDomain(_ref) {
	  var name = _ref.name,
	      comp_id = _ref.comp_id;
	  return _http.http.post('/companies/domains', { name: name, comp_id: comp_id }).then(_get.getData);
	};
	var updateDomainData = exports.updateDomainData = function updateDomainData(_ref2) {
	  var id = _ref2.id,
	      comp_id = _ref2.comp_id;
	  return _http.http.post('/companies/domains/update', { id: id, comp_id: comp_id }).then(_get.getData);
	};
	
	var verifyNewDomain = exports.verifyNewDomain = function verifyNewDomain(_ref3) {
	  var id = _ref3.id;
	  return _http.http.post('/companies/domains/verify', { id: id }).then(_get.getData);
	};
	
	var verifyTxtRecord = exports.verifyTxtRecord = function verifyTxtRecord(_ref4) {
	  var id = _ref4.id;
	  return _http.http.post('/companies/domains/verifytxtrecord', { id: id }).then(_get.getData);
	};
	
	var deleteDomain = exports.deleteDomain = function deleteDomain(_ref5) {
	  var id = _ref5.id;
	  return _http.http.delete('/companies/domains/' + id).then(_get.getData);
	};
	
	var getCompanySubOrg = exports.getCompanySubOrg = function getCompanySubOrg() {
	  return _http.http.get('/reports/company/suborg').then(_get.getData);
	};

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_DOMAIN_LIST = exports.SET_DOMAIN_LIST = 'Company//SET_DOMAIN_LIST';

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(107);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  domains: [],
	  messages: _state2.default.messages
	};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(514);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(525);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(527);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(531);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _state = __webpack_require__(107);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(543);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(540);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _modules = __webpack_require__(542);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _plugins = __webpack_require__(544);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _getters = __webpack_require__(541);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  state: _state2.default,
	  mutations: _mutations2.default,
	  actions: _actions2.default,
	  modules: _modules2.default,
	  plugins: _plugins2.default,
	  getters: getters,
	  strict: ("production") !== 'production'
	});

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MAIN_SET_MESSAGE = exports.MAIN_SET_MESSAGE = 'MAIN_SET_MESSAGE';
	var MAIN_SET_FETCHING = exports.MAIN_SET_FETCHING = 'MAIN_SET_FETCHING';
	
	var CATEGORIES_SET_DATA = exports.CATEGORIES_SET_DATA = 'CATEGORIES_SET_DATA';
	var PRODUCTS_SET_DATA = exports.PRODUCTS_SET_DATA = 'PRODUCTS_SET_DATA';

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 189,
		"./af.js": 189,
		"./ar": 196,
		"./ar-dz": 190,
		"./ar-dz.js": 190,
		"./ar-kw": 191,
		"./ar-kw.js": 191,
		"./ar-ly": 192,
		"./ar-ly.js": 192,
		"./ar-ma": 193,
		"./ar-ma.js": 193,
		"./ar-sa": 194,
		"./ar-sa.js": 194,
		"./ar-tn": 195,
		"./ar-tn.js": 195,
		"./ar.js": 196,
		"./az": 197,
		"./az.js": 197,
		"./be": 198,
		"./be.js": 198,
		"./bg": 199,
		"./bg.js": 199,
		"./bm": 200,
		"./bm.js": 200,
		"./bn": 201,
		"./bn.js": 201,
		"./bo": 202,
		"./bo.js": 202,
		"./br": 203,
		"./br.js": 203,
		"./bs": 204,
		"./bs.js": 204,
		"./ca": 205,
		"./ca.js": 205,
		"./cs": 206,
		"./cs.js": 206,
		"./cv": 207,
		"./cv.js": 207,
		"./cy": 208,
		"./cy.js": 208,
		"./da": 209,
		"./da.js": 209,
		"./de": 212,
		"./de-at": 210,
		"./de-at.js": 210,
		"./de-ch": 211,
		"./de-ch.js": 211,
		"./de.js": 212,
		"./dv": 213,
		"./dv.js": 213,
		"./el": 214,
		"./el.js": 214,
		"./en-au": 215,
		"./en-au.js": 215,
		"./en-ca": 216,
		"./en-ca.js": 216,
		"./en-gb": 217,
		"./en-gb.js": 217,
		"./en-ie": 218,
		"./en-ie.js": 218,
		"./en-nz": 219,
		"./en-nz.js": 219,
		"./eo": 220,
		"./eo.js": 220,
		"./es": 223,
		"./es-do": 221,
		"./es-do.js": 221,
		"./es-us": 222,
		"./es-us.js": 222,
		"./es.js": 223,
		"./et": 224,
		"./et.js": 224,
		"./eu": 225,
		"./eu.js": 225,
		"./fa": 226,
		"./fa.js": 226,
		"./fi": 227,
		"./fi.js": 227,
		"./fo": 228,
		"./fo.js": 228,
		"./fr": 231,
		"./fr-ca": 229,
		"./fr-ca.js": 229,
		"./fr-ch": 230,
		"./fr-ch.js": 230,
		"./fr.js": 231,
		"./fy": 232,
		"./fy.js": 232,
		"./gd": 233,
		"./gd.js": 233,
		"./gl": 234,
		"./gl.js": 234,
		"./gom-latn": 235,
		"./gom-latn.js": 235,
		"./gu": 236,
		"./gu.js": 236,
		"./he": 237,
		"./he.js": 237,
		"./hi": 238,
		"./hi.js": 238,
		"./hr": 239,
		"./hr.js": 239,
		"./hu": 240,
		"./hu.js": 240,
		"./hy-am": 241,
		"./hy-am.js": 241,
		"./id": 242,
		"./id.js": 242,
		"./is": 243,
		"./is.js": 243,
		"./it": 244,
		"./it.js": 244,
		"./ja": 245,
		"./ja.js": 245,
		"./jv": 246,
		"./jv.js": 246,
		"./ka": 247,
		"./ka.js": 247,
		"./kk": 248,
		"./kk.js": 248,
		"./km": 249,
		"./km.js": 249,
		"./kn": 250,
		"./kn.js": 250,
		"./ko": 251,
		"./ko.js": 251,
		"./ky": 252,
		"./ky.js": 252,
		"./lb": 253,
		"./lb.js": 253,
		"./lo": 254,
		"./lo.js": 254,
		"./lt": 255,
		"./lt.js": 255,
		"./lv": 256,
		"./lv.js": 256,
		"./me": 257,
		"./me.js": 257,
		"./mi": 258,
		"./mi.js": 258,
		"./mk": 259,
		"./mk.js": 259,
		"./ml": 260,
		"./ml.js": 260,
		"./mr": 261,
		"./mr.js": 261,
		"./ms": 263,
		"./ms-my": 262,
		"./ms-my.js": 262,
		"./ms.js": 263,
		"./my": 264,
		"./my.js": 264,
		"./nb": 265,
		"./nb.js": 265,
		"./ne": 266,
		"./ne.js": 266,
		"./nl": 268,
		"./nl-be": 267,
		"./nl-be.js": 267,
		"./nl.js": 268,
		"./nn": 269,
		"./nn.js": 269,
		"./pa-in": 270,
		"./pa-in.js": 270,
		"./pl": 271,
		"./pl.js": 271,
		"./pt": 273,
		"./pt-br": 272,
		"./pt-br.js": 272,
		"./pt.js": 273,
		"./ro": 274,
		"./ro.js": 274,
		"./ru": 275,
		"./ru.js": 275,
		"./sd": 276,
		"./sd.js": 276,
		"./se": 277,
		"./se.js": 277,
		"./si": 278,
		"./si.js": 278,
		"./sk": 279,
		"./sk.js": 279,
		"./sl": 280,
		"./sl.js": 280,
		"./sq": 281,
		"./sq.js": 281,
		"./sr": 283,
		"./sr-cyrl": 282,
		"./sr-cyrl.js": 282,
		"./sr.js": 283,
		"./ss": 284,
		"./ss.js": 284,
		"./sv": 285,
		"./sv.js": 285,
		"./sw": 286,
		"./sw.js": 286,
		"./ta": 287,
		"./ta.js": 287,
		"./te": 288,
		"./te.js": 288,
		"./tet": 289,
		"./tet.js": 289,
		"./th": 290,
		"./th.js": 290,
		"./tl-ph": 291,
		"./tl-ph.js": 291,
		"./tlh": 292,
		"./tlh.js": 292,
		"./tr": 293,
		"./tr.js": 293,
		"./tzl": 294,
		"./tzl.js": 294,
		"./tzm": 296,
		"./tzm-latn": 295,
		"./tzm-latn.js": 295,
		"./tzm.js": 296,
		"./uk": 297,
		"./uk.js": 297,
		"./ur": 298,
		"./ur.js": 298,
		"./uz": 300,
		"./uz-latn": 299,
		"./uz-latn.js": 299,
		"./uz.js": 300,
		"./vi": 301,
		"./vi.js": 301,
		"./x-pseudo": 302,
		"./x-pseudo.js": 302,
		"./yo": 303,
		"./yo.js": 303,
		"./zh-cn": 304,
		"./zh-cn.js": 304,
		"./zh-hk": 305,
		"./zh-hk.js": 305,
		"./zh-tw": 306,
		"./zh-tw.js": 306
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 188;


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    auth: __webpack_require__(783),
	    recipient: __webpack_require__(787),
	    company: __webpack_require__(785),
	    campaign: __webpack_require__(784),
	    report: __webpack_require__(788),
	    leaderboard: __webpack_require__(786)
	
	};

/***/ }),

/***/ 356:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  messages: {
	    alpha_spaces: function alpha_spaces() {
	      return 'Only alphabets and spaces are allowed.';
	    }
	  },
	  attributes: {
	    first_name: 'first name',
	    last_name: 'last name',
	    designation: 'Job title ',
	    company: 'organisation ',
	    employ_count: 'employee number',
	    confirm_password: 're-type password',
	    agree: 'agree to the terms of service and privacy policy'
	  }
	};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(355).default
	};

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: __webpack_require__(356).default
	};

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'HumanFirewall'
	};

/***/ }),

/***/ 490:
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(108);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _lodash = __webpack_require__(7);
	
	var _vuex = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        show: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['messages']), {
	        hasSuccessMessage: function hasSuccessMessage() {
	            return this.messages.success !== '';
	        },
	        hasErrorMessages: function hasErrorMessages() {
	            return this.show.hasOwnProperty('errors') && (0, _typeof3.default)(this.messages.error) === 'object' && this.messages.error.length > 0;
	        },
	        hasWarningMessages: function hasWarningMessages() {
	            return this.messages.warning !== '';
	        },
	        hasValidationMessages: function hasValidationMessages() {
	            return this.messages.validation.length > 0;
	        },
	        formatedErrorMessage: function formatedErrorMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.error).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        },
	        formatedValidationMessage: function formatedValidationMessage() {
	            return (0, _lodash.flatMapDeep)(this.messages.validation).map(function (msg) {
	                return '\u2022 ' + msg;
	            }).join('<br>');
	        }
	    }),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage']), {
	        dismiss: function dismiss(type) {
	            var obj = void 0;
	            if (type === 'error') {
	                obj = { type: type, message: {} };
	            } else if (type === 'validation') {
	                obj = { type: type, message: {} };
	            } else {
	                obj = { type: type, message: '' };
	            }
	            this.setMessage(obj);
	        }
	    })
	};

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(6);
	
	var _navbar = __webpack_require__(934);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _sidebar = __webpack_require__(935);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        NavBar: _navbar2.default, SideBar: _sidebar2.default
	    },
	    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['shouldShowNavigation']))
	
	};

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(6);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				company_logo: '',
				company_logo_exist: 2,
				status: '',
				selected_company: '',
				company_id: '',
				permissions: {
					general: 1
				},
				remaining_days: '',
				quickmenu: '',
				activemenu: 'text-complete',
				currentRouteName: '',
				user: {}
			};
		},
	
		props: ['type', 'routeHeader', 'routePath', 'modifyData', 'refreshCampaignComponent', 'suborg'],
		beforeMount: function beforeMount() {
			var _this = this;
	
			var currentURL = window.location.pathname;
			this.currentURL = currentURL;
			var permissions = JSON.parse(localStorage.getItem("permissions"));
			if (permissions) {
				this.permissions.general = permissions.general;
			}
	
			if (this.$route.path == '/') {
				this.$router.push({ name: 'auth.showoptions' });
				return false;
			}
	
			this.$http.get('/setting/company_logo').then(function (response) {
				_this.company_logo_exist = 1;
				_this.company_logo = response.data.data.logo;
				_this.company_id = response.data.data.company_id;
				_this.status = response.data.data.status;
				_this.selected_company = response.data.data.selected_company;
			});
			this.remaining_days = JSON.parse(localStorage.getItem('expired_in'));
			if (!this.currentUser) {
				this.$router.push({ name: 'auth.login' });
			}
			this.currentRouteName = this.$router.currentRoute.name;
	
			this.user = JSON.parse(localStorage.getItem('user'));
		},
	
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['currentUser'])),
		methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
			logoutUser: function logoutUser() {
	
				this.logout();
				localStorage.setItem('user', null);
	
				window.location = _config.appUrl + '/logout';
			},
			updateAdminLogin: function updateAdminLogin() {
				var data = {};
				data.admin_company_id = this.company_id;
				this.$http.post('/adminlogin/updateadminlogin', data).then(function (response) {
					if (response.data) {
						location.reload();
					}
				});
			},
			quickview: function quickview() {
				if (this.quickmenu == 'open') {
					this.quickmenu = '';
				} else {
					this.quickmenu = 'open';
				}
			}
		})
	};

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      user_permission: {
	        data: {
	          campaign_view: '',
	          campaign_create: '',
	          campaign_schedule: '',
	          announcement_view: '',
	          announcement_create: '',
	          view_recepients: '',
	          add_new_recepients: '',
	          view_report: '',
	          add_new_report: '',
	          domain: '',
	          general: '',
	          user_management: '',
	          retest_frequency: '',
	          direct_learning_management: '',
	          direct_learning_invitation_mail: '',
	          direct_learning_login_mail: '',
	          direct_learning_with_username_and_password_mail: '',
	          landing_oops: '',
	          training_mail: '',
	          email_setting: '',
	          company_logo: {
	            logo: ''
	          }
	        }
	      }
	    };
	  }
	};

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(497);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var adn = function adn(r) {
	  return __webpack_require__.e/* nsure */(24, function () {
	    return r(__webpack_require__(803));
	  });
	};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var Auth = {
	    login: function login(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(806));
	        });
	    },
	    register: function register(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(808));
	        });
	    },
	    verification: function verification(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(812));
	        });
	    },
	    'learning': function learning(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(805));
	        });
	    },
	    'learningdashboard': function learningdashboard(r) {
	        return __webpack_require__.e/* nsure */(15, function () {
	            return r(__webpack_require__(841));
	        });
	    },
	    'learningdashboardAR': function learningdashboardAR(r) {
	        return __webpack_require__.e/* nsure */(16, function () {
	            return r(__webpack_require__(840));
	        });
	    },
	    'learningreport': function learningreport(r) {
	        return __webpack_require__.e/* nsure */(14, function () {
	            return r(__webpack_require__(842));
	        });
	    },
	    'registered': function registered(r) {
	        return __webpack_require__.e/* nsure */(19, function () {
	            return r(__webpack_require__(809));
	        });
	    },
	
	    'showoptions': function showoptions(r) {
	        return __webpack_require__.e/* nsure */(13, function () {
	            return r(__webpack_require__(99));
	        });
	    },
	    'showoptions_arabic': function showoptions_arabic(r) {
	        return __webpack_require__.e/* nsure */(22, function () {
	            return r(__webpack_require__(810));
	        });
	    },
	    'selectLang': function selectLang(r) {
	        return __webpack_require__.e/* nsure */(11, function () {
	            return r(__webpack_require__(843));
	        });
	    }
	};
	
	var ForgetPassword = function ForgetPassword(r) {
	    return __webpack_require__.e/* nsure */(20, function () {
	        return r(__webpack_require__(804));
	    });
	};
	var PrivacyPolicy = function PrivacyPolicy(r) {
	    return __webpack_require__.e/* nsure */(23, function () {
	        return r(__webpack_require__(807));
	    });
	};
	var termsAndConditions = function termsAndConditions(r) {
	    return __webpack_require__.e/* nsure */(21, function () {
	        return r(__webpack_require__(811));
	    });
	};
	
	exports.default = [{
	    name: 'auth.login',
	    path: '/lms/course',
	    component: Auth.login,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.register',
	    path: '/register',
	    component: Auth.register,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learning',
	    path: '/learning/login/:id',
	    component: Auth.learning,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningdashboard',
	    path: '/learning/dashboard/:id',
	    component: Auth.learningdashboard,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningdashboard',
	    path: '/learning_ar/dashboard/:id',
	    component: Auth.learningdashboardAR,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningreport',
	    path: '/learning/reports/:id',
	    component: Auth.learningreport,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.verification',
	    path: '/verification',
	    component: Auth.verification,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.reset',
	    path: '/reset',
	    component: ForgetPassword,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.privacypolicy',
	    path: '/privacypolicy',
	    component: PrivacyPolicy,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.termsAndConditions',
	    path: '/TermsAndConditions',
	    component: termsAndConditions,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.licenceexpire',
	    path: '/licenceexpire',
	    component: Auth.licenceexpire,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.registered',
	    path: '/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.showoptions',
	    path: '/',
	    component: Auth.showoptions,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.showoptions_arabic',
	    path: '/options_arabic',
	    component: Auth.showoptions_arabic,
	    meta: { requiresAuth: false }
	}, {
	    name: 'auth.learningdashboardlang',
	    path: '/learning/language',
	    component: Auth.selectLang,
	    meta: { requiresAuth: false }
	}];

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.loadUser = exports.checkUserToken = exports.setToken = exports.setUser = exports.logout = exports.attemptVerification = exports.loginLmsUser = exports.loginUser = exports.attemptRegister = exports.attemptLearningLogin = exports.attemptLogin = undefined;
	
	var _promise = __webpack_require__(88);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(15);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _localforage = __webpack_require__(132);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(4);
	
	var _lodash = __webpack_require__(7);
	
	var _mutationsTypes = __webpack_require__(104);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _services = __webpack_require__(103);
	
	var services = _interopRequireWildcard(_services);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var attemptLogin = exports.attemptLogin = function attemptLogin(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.postLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptLearningLogin = exports.attemptLearningLogin = function attemptLearningLogin(_ref2, payload) {
	  var dispatch = _ref2.dispatch;
	  return services.postLearningLogin(payload).then(function (response) {
	    return response;
	  });
	};
	
	var attemptRegister = exports.attemptRegister = function attemptRegister(_ref3, payload) {
	  var dispatch = _ref3.dispatch;
	  return services.postRegister(payload).then(function (response) {
	    return response;
	  });
	};
	
	var loginUser = exports.loginUser = function loginUser(_ref4, response) {
	  var dispatch = _ref4.dispatch;
	
	  dispatch('setToken', response.token);
	  dispatch('setUser', response);
	  localStorage.setItem('user', (0, _stringify2.default)(response));
	};
	
	var loginLmsUser = exports.loginLmsUser = function loginLmsUser(_ref5, response) {
	  var dispatch = _ref5.dispatch;
	
	  dispatch('setToken', response.token);
	  dispatch('setUser', response);
	  localStorage.setItem('user', (0, _stringify2.default)(response));
	};
	
	var attemptVerification = exports.attemptVerification = function attemptVerification(_ref6, payload) {
	  var dispatch = _ref6.dispatch;
	  return services.postVerification(payload).then(function (response) {
	    dispatch('setToken', null);
	    dispatch('setToken', response.data.token);
	    dispatch('setUser', response.data);
	    localStorage.setItem('user', (0, _stringify2.default)(response.data));
	
	    return response;
	  });
	};
	
	var logout = exports.logout = function logout(_ref7) {
	  var dispatch = _ref7.dispatch;
	
	  return _promise2.default.all([dispatch('setToken', null), dispatch('setUser', {})]);
	};
	
	var setUser = exports.setUser = function setUser(_ref8, user) {
	  var commit = _ref8.commit;
	
	  commit(TYPES.SET_USER, user);
	
	  _promise2.default.resolve(user);
	};
	
	var setToken = exports.setToken = function setToken(_ref9, payload) {
	  var commit = _ref9.commit;
	
	  var token = (0, _lodash.isEmpty)(payload) ? null : payload.token || payload;
	
	  commit(TYPES.SET_TOKEN, token);
	
	  return _promise2.default.resolve(token);
	};
	
	var checkUserToken = exports.checkUserToken = function checkUserToken(_ref10) {
	  var dispatch = _ref10.dispatch,
	      state = _ref10.state;
	
	  if (!(0, _lodash.isEmpty)(state.token)) {
	    return _promise2.default.resolve(state.token);
	  }
	
	  return _localforage2.default.getItem(_config.userTokenStorageKey).then(function (token) {
	    if ((0, _lodash.isEmpty)(token)) {
	      return _promise2.default.reject('NO_TOKEN');
	    }
	
	    return dispatch('setToken', token);
	  }).then(function () {
	    return dispatch('loadUser');
	  });
	};
	
	var loadUser = exports.loadUser = function loadUser(_ref11) {
	  var dispatch = _ref11.dispatch;
	
	  var user = JSON.parse(localStorage.getItem('user'));
	  ;
	  return _promise2.default.resolve(dispatch('setUser', user));
	};

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentUser = exports.isLogged = undefined;
	
	var _lodash = __webpack_require__(7);
	
	var isLogged = exports.isLogged = function isLogged(_ref) {
	  var token = _ref.token;
	  return !(0, _lodash.isEmpty)(token);
	};
	var currentUser = exports.currentUser = function currentUser(_ref2) {
	  var user = _ref2.user;
	  return user;
	};

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(504);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(502);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _plugin = __webpack_require__(503);
	
	var _plugin2 = _interopRequireDefault(_plugin);
	
	var _actions = __webpack_require__(499);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(500);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, mutations: _mutations2.default, actions: actions, getters: getters };
	
	exports.default = { module: _module, plugin: _plugin2.default };

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(11);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$SET_TOKEN$TYPE;
	
	var _mutationsTypes = __webpack_require__(104);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$SET_TOKEN$TYPE = {}, (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_TOKEN, function (state, value) {
	  state.token = value;
	}), (0, _defineProperty3.default)(_TYPES$SET_TOKEN$TYPE, TYPES.SET_USER, function (state, value) {
	  state.user = value;
	}), _TYPES$SET_TOKEN$TYPE);

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localforage = __webpack_require__(132);
	
	var _localforage2 = _interopRequireDefault(_localforage);
	
	var _config = __webpack_require__(4);
	
	var _http = __webpack_require__(5);
	
	var _mutationsTypes = __webpack_require__(104);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscribe = function subscribe(store) {
	  store.subscribe(function (mutation, _ref) {
	    var Auth = _ref.Auth;
	
	    if (TYPES.SET_TOKEN === mutation.type) {
	      (0, _http.setToken)(Auth.token);
	
	      _localforage2.default.setItem(_config.userTokenStorageKey, Auth.token);
	    }
	  });
	};
	
	exports.default = function (store) {
	  subscribe(store);
	};

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(107);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  user: {},
	  token: null
	};

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(816));
	    });
	};
	
	var previewScenario = function previewScenario(r) {
	    return __webpack_require__.e/* nsure */(17, function () {
	        return r(__webpack_require__(817));
	    });
	};
	
	var bulk_campaign_preview = function bulk_campaign_preview(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(813));
	    });
	};
	
	var bulk_campaign_preview_edit = function bulk_campaign_preview_edit(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(814));
	    });
	};
	
	var manageCampaign = {
	
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(815));
	        });
	    }
	
	};
	
	exports.default = [{
	    name: 'bulk_campaigns',
	    path: '/bulk/campaigns',
	
	    component: campaigns
	
	}, {
	    name: 'bulk_campaigns.schedule',
	    path: '/bulk/campains/schedule/:id',
	
	    component: manageCampaign.create
	}, {
	    name: 'previewScenario',
	    path: '/previewScenario/:id',
	    component: previewScenario
	}, {
	    name: 'bulkcampaign_preview',
	    path: '/bulk_campaign/preview/:id',
	    component: bulk_campaign_preview
	}, {
	    name: 'bulkcampaign_preview_edit',
	    path: '/bulk_campaign/preview/edit/:id',
	    component: bulk_campaign_preview_edit
	}];

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(507);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Auth = {
	    login: function login(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(819));
	        });
	    },
	    register: function register(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(820));
	        });
	    },
	    twofa: function twofa(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(822));
	        });
	    },
	    comingsoon: function comingsoon(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(818));
	        });
	    },
	    registered: function registered(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(821));
	        });
	    }
	};
	exports.default = [{
	    name: 'c.login',
	    path: '/c/login',
	    component: Auth.login,
	    meta: { requiresAuth: false }
	}, {
	    name: 'c.register',
	    path: '/c/register',
	    component: Auth.register,
	    meta: { requiresAuth: false }
	}, {
	    name: 'c.twofa',
	    path: '/c/twofa',
	    component: Auth.twofa,
	    meta: { requiresAuth: false }
	}, {
	    name: 'c.comingsoon',
	    path: '/c/comingsoon',
	    component: Auth.comingsoon,
	    meta: { requiresAuth: false }
	}, {
	    name: 'c.registered',
	    path: '/c/registered',
	    component: Auth.registered,
	    meta: { requiresAuth: false }
	}];

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var campaigns = function campaigns(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(824));
	    });
	};
	var preview = function preview(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(834));
	    });
	};
	var bulkpreview = function bulkpreview(r) {
	    return __webpack_require__.e/* nsure */(6, function () {
	        return r(__webpack_require__(823));
	    });
	};
	var manageCampaign = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(833));
	        });
	    },
	    create: function create(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(825));
	        });
	    },
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(826));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(828));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(832));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(829));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(827));
	        });
	    },
	    schedule: function schedule(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(831));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(3, function () {
	            return r(__webpack_require__(830));
	        });
	    }
	};
	
	exports.default = [{
	    name: 'campaigns',
	    path: '/campaigns',
	    alias: '/announcements',
	    component: campaigns
	}, {
	    name: 'preview',
	    path: '/campaigns/preview/:id',
	    alias: '/announcements/preview/:id',
	    component: preview
	}, {
	    name: 'bulk/preview',
	    path: '/campaigns/bulk/preview/:id',
	    component: bulkpreview
	}, {
	    name: 'campaigns.index',
	    path: '/campains/create',
	    alias: '/announcements/create',
	    component: manageCampaign.index,
	    redirect: { name: 'campaigns.create' },
	    children: [{
	        name: 'campaigns.create',
	        path: '/campaigns/create',
	        alias: '/announcements/create',
	        component: manageCampaign.create
	    }, {
	        name: 'campaigns.edit.description',
	        path: '/campaigns/description/:id',
	        alias: '/announcements/description/:id',
	        component: manageCampaign.description
	    }, {
	        name: 'campaigns.edit.email',
	        path: '/campaigns/email/:id',
	        alias: '/announcements/email/:id',
	        component: manageCampaign.email
	    }, {
	        name: 'campaigns.edit.sms',
	        path: '/campaigns/sms/:id',
	        alias: '/announcements/sms/:id',
	        component: manageCampaign.sms
	    }, {
	        name: 'campaigns.edit.landing',
	        path: '/campaigns/landing/:id',
	        alias: '/announcements/landing/:id',
	        component: manageCampaign.landing
	    }, {
	        name: 'campaigns.edit.education',
	        path: '/campaigns/education/:id',
	        alias: '/announcements/education/:id',
	        component: manageCampaign.education
	    }, {
	        name: 'campaigns.edit.schedule',
	        path: '/campaigns/schedule/:id',
	        alias: '/announcements/schedule/:id',
	        component: manageCampaign.schedule
	    }, {
	        name: 'campaigns.edit.review',
	        path: '/campaigns/review/:id',
	        alias: '/announcements/review/:id',
	        component: manageCampaign.review
	    }]
	}];

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var domains = function domains(r) {
	    return __webpack_require__.e/* nsure */(18, function () {
	        r(__webpack_require__(835));
	    });
	};
	
	exports.default = [{
	    name: 'company.domains',
	    path: '/company/domains',
	    component: domains
	}];

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDomains = exports.LOAD_DOMAIN_LIST = exports.addCompanyDomain = undefined;
	
	var _promise = __webpack_require__(88);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _services = __webpack_require__(145);
	
	var services = _interopRequireWildcard(_services);
	
	var _mutationsTypes = __webpack_require__(146);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	var _state = __webpack_require__(147);
	
	var _state2 = _interopRequireDefault(_state);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addCompanyDomain = exports.addCompanyDomain = function addCompanyDomain(_ref, payload) {
	  var dispatch = _ref.dispatch;
	  return services.addNewDomain(payload).then(function (_ref2) {
	    var message = _ref2.message,
	        status_code = _ref2.status_code;
	
	    console.log(message, status_code);
	  });
	};
	
	var LOAD_DOMAIN_LIST = exports.LOAD_DOMAIN_LIST = function LOAD_DOMAIN_LIST(_ref3) {
	  var dispatch = _ref3.dispatch;
	
	
	  services.getDomains().then(function (response) {
	    console.log('state', _state2.default);
	
	    dispatch('setDomains', response.data);
	    return _promise2.default.resolve(response);
	  }).catch(function (error) {
	
	    console.log('error', error);
	    return _promise2.default.reject('FAIL_IN_LOAD_COMPANY_DOMAINS');
	  });
	};
	
	var setDomains = exports.setDomains = function setDomains(_ref4, list) {
	  var commit = _ref4.commit;
	
	  console.log('commiter', commit);
	  console.log('list', list);
	
	  commit(TYPES.SET_DOMAIN_LIST, list);
	
	  console.log(_state2.default);
	
	  return _promise2.default.resolve(list);
	};

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getDomains = exports.getDomains = function getDomains(_ref) {
	  var state = _ref.state;
	  return state.domains;
	};

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _state = __webpack_require__(147);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _mutations = __webpack_require__(513);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(510);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(511);
	
	var getters = _interopRequireWildcard(_getters);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = { state: _state2.default, actions: actions, mutations: _mutations2.default, getters: getters };
	
	exports.default = { module: _module };

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(11);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutationsTypes = __webpack_require__(146);
	
	var TYPES = _interopRequireWildcard(_mutationsTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({}, TYPES.SET_DOMAIN_LIST, function (state, list) {
	    state.domains = list;
	});

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Dashboard = function Dashboard(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(837));
	  });
	};
	var CompanyList = function CompanyList(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(836));
	  });
	};
	var ReportedPluginUsers = function ReportedPluginUsers(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(838));
	  });
	};
	var WeakestLinkUser = function WeakestLinkUser(r) {
	  return __webpack_require__.e/* nsure */(10, function () {
	    return r(__webpack_require__(839));
	  });
	};
	
	exports.default = [{
	  name: 'pluginusers',
	  path: '/reported/pluginusers',
	  component: ReportedPluginUsers
	}, {
	  name: 'dashboard.companylist',
	  path: '/companylist',
	  component: CompanyList
	}, {
	  name: 'dashboard.weakestlinkuser',
	  path: '/weakestlink',
	  component: WeakestLinkUser
	}];

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(516);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var laggards = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(845));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(844));
					});
			}
	};
	
	exports.default = [{
			name: 'laggards',
			path: '/laggards',
			component: laggards.index
	}, {
			name: 'laggards.edit',
			path: '/laggards/:id',
			component: laggards.edit
	}];

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(518);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var leaderboard = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(847));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(846));
					});
			}
	};
	
	exports.default = [{
			name: 'leaderboard',
			path: '/leaderboard',
			component: leaderboard.index
	}, {
			name: 'leaderboard.edit',
			path: '/leaderboard/:id',
			component: leaderboard.edit
	}];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(521);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                                value: true
	});
	var courses = exports.courses = function courses(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(854));
	                                });
	};
	var Reports = exports.Reports = function Reports(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(863));
	                                });
	};
	var Learners = exports.Learners = function Learners(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(864));
	                                });
	};
	var License = exports.License = function License(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(865));
	                                });
	};
	var Departments = exports.Departments = function Departments(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(862));
	                                });
	};
	var Courses = exports.Courses = function Courses(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(860));
	                                });
	};
	
	var DepartmentTargets = exports.DepartmentTargets = function DepartmentTargets(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(861));
	                                });
	};
	var TargetCourses = exports.TargetCourses = function TargetCourses(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(866));
	                                });
	};
	
	var Emaillogs = exports.Emaillogs = function Emaillogs(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(859));
	                                });
	};
	
	var login = exports.login = function login(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(99));
	                                });
	};
	var login_ar = exports.login_ar = function login_ar(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(311));
	                                });
	};
	var user_choice = exports.user_choice = function user_choice(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(312));
	                                });
	};
	var user_license = exports.user_license = function user_license(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(314));
	                                });
	};
	var user_entity_license = exports.user_entity_license = function user_entity_license(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(313));
	                                });
	};
	var confirmation = exports.confirmation = function confirmation(r) {
	                                return __webpack_require__.e/* nsure */(2, function () {
	                                                                return r(__webpack_require__(310));
	                                });
	};

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _components = __webpack_require__(520);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Auth = {
	    login: function login(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(99));
	        });
	    },
	    login_ar: function login_ar(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(311));
	        });
	    },
	    user_choice: function user_choice(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(312));
	        });
	    },
	    user_license: function user_license(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(314));
	        });
	    },
	    user_entity_license: function user_entity_license(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(313));
	        });
	    },
	    confirmation: function confirmation(r) {
	        return __webpack_require__.e/* nsure */(2, function () {
	            return r(__webpack_require__(310));
	        });
	    }
	};
	var manageCourse = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(7, function () {
	            return r(__webpack_require__(857));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(7, function () {
	            return r(__webpack_require__(856));
	        });
	    },
	    notification: function notification(r) {
	        return __webpack_require__.e/* nsure */(7, function () {
	            return r(__webpack_require__(858));
	        });
	    },
	    completion: function completion(r) {
	        return __webpack_require__.e/* nsure */(7, function () {
	            return r(__webpack_require__(853));
	        });
	    },
	    enrolments: function enrolments(r) {
	        return __webpack_require__.e/* nsure */(7, function () {
	            return r(__webpack_require__(855));
	        });
	    }
	};
	var manageSetting = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(870));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(869));
	        });
	    },
	    gamification: function gamification(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(868));
	        });
	    },
	    certificate: function certificate(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(867));
	        });
	    },
	    notificationstemplates: function notificationstemplates(r) {
	        return __webpack_require__.e/* nsure */(8, function () {
	            return r(__webpack_require__(871));
	        });
	    }
	};
	var editCourse = {
	    editindex: function editindex(r) {
	        return __webpack_require__.e/* nsure */(9, function () {
	            return r(__webpack_require__(851));
	        });
	    },
	    general: function general(r) {
	        return __webpack_require__.e/* nsure */(9, function () {
	            return r(__webpack_require__(850));
	        });
	    },
	    notification: function notification(r) {
	        return __webpack_require__.e/* nsure */(9, function () {
	            return r(__webpack_require__(852));
	        });
	    },
	    completion: function completion(r) {
	        return __webpack_require__.e/* nsure */(9, function () {
	            return r(__webpack_require__(848));
	        });
	    },
	    enrolments: function enrolments(r) {
	        return __webpack_require__.e/* nsure */(9, function () {
	            return r(__webpack_require__(849));
	        });
	    }
	};
	exports.default = [{
	    name: 'lms.login',
	    path: '/lms/login',
	    component: Auth.login,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.login_ar',
	    path: '/lms/login_ar',
	    component: Auth.login_ar,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.user_choice',
	    path: '/lms/user_choice',
	    component: Auth.user_choice,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.user_license',
	    path: '/lms/user_license',
	    component: Auth.user_license,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.user_entity_license',
	    path: '/lms/user_entity_license',
	    component: Auth.user_entity_license,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.confirmation',
	    path: '/lms/confirmation',
	    component: Auth.confirmation,
	    meta: { requiresAuth: false }
	}, {
	    name: 'lms.courses',
	    path: '/',
	    component: component.courses
	}, {
	    name: 'lms.courses2',
	    path: '/lms/courses',
	    component: component.courses
	}, {
	    name: 'lms.index',
	    path: '/lms/general/:id',
	    component: manageCourse.index,
	    redirect: { name: 'lms.general/:id' },
	    children: [{
	        name: 'lms.general',
	        path: '/lms/general/:id',
	        component: manageCourse.general
	    }, {
	        name: 'lms.notification',
	        path: '/lms/notification/:id',
	        component: manageCourse.notification
	    }, {
	        name: 'lms.completion',
	        path: '/lms/completion/:id',
	        component: manageCourse.completion
	    }, {
	        name: 'lms.enrolments',
	        path: '/lms/enrolments/:id',
	        component: manageCourse.enrolments
	    }]
	}, {
	    name: 'lms.editindex',
	    path: '/lms/editgeneral/:id',
	    component: editCourse.editindex,
	    redirect: { name: 'lms.editgeneral' },
	    children: [{
	        name: 'lms.editgeneral',
	        path: '/lms/editgeneral/:id',
	        component: editCourse.editgeneral
	    }, {
	        name: 'lms.editnotification',
	        path: '/lms/editnotification/:id',
	        component: editCourse.editnotification
	    }, {
	        name: 'lms.editcompletion',
	        path: '/lms/editcompletion/:id',
	        component: editCourse.editcompletion
	    }, {
	        name: 'lms.editenrolments',
	        path: '/lms/editenrolments/:id',
	        component: editCourse.editenrolments
	    }]
	}, {
	    name: 'lms.index',
	    path: '/lms/setting',
	    component: manageSetting.index,
	    redirect: { name: 'lms.setting' },
	    children: [{
	        name: 'lms.setting',
	        path: '/lms/setting',
	        component: manageSetting.general
	    }, {
	        name: 'lms.gamification',
	        path: '/lms/gamification',
	        component: manageSetting.gamification
	    }, {
	        name: 'lms.certificate',
	        path: '/lms/certificate',
	        component: manageSetting.certificate
	    }, {
	        name: 'lms.notificationstemplates',
	        path: '/lms/notificationstemplates',
	        component: manageSetting.notificationstemplates
	    }]
	}, {
	    name: 'lms.reports',
	    path: '/lms/reports',
	    component: component.Reports
	}, {
	    name: 'lms.reportcourses',
	    path: '/lms/reports/courses',
	    component: component.Courses
	}, {
	    name: 'lms.license',
	    path: '/lms/reports/license',
	    component: component.License
	}, {
	    name: 'lms.learner_results',
	    path: '/lms/reports/learner_results',
	    component: component.Courses
	}, {
	    name: 'lms.reportdepartments',
	    path: '/lms/reports/departments',
	    component: component.Departments
	}, {
	    name: 'lms.reportlearners',
	    path: '/lms/reports/learners',
	    component: component.Learners
	}, {
	    name: 'lms.reportdepartment_targets',
	    path: '/lms/reports/department_targets',
	    component: component.DepartmentTargets
	}, {
	    name: 'lms.reporttarget_courses',
	    path: '/lms/reports/target_courses',
	    component: component.TargetCourses
	}, {
	    name: 'lms.emaillogs',
	    path: '/lms/emaillogs',
	    component: component.Emaillogs
	}];

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(524);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PhishingVulnerabilityTrend = exports.PhishingVulnerabilityTrend = function PhishingVulnerabilityTrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(875));
	  });
	};
	
	var AwarenessTrendsLook = exports.AwarenessTrendsLook = function AwarenessTrendsLook(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(872));
	  });
	};
	
	var ReportingTrend = exports.ReportingTrend = function ReportingTrend(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(876));
	  });
	};
	
	var Weekest = exports.Weekest = function Weekest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(878));
	  });
	};
	
	var Strongest = exports.Strongest = function Strongest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(877));
	  });
	};
	
	var Deparmentweakest = exports.Deparmentweakest = function Deparmentweakest(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(873));
	  });
	};
	
	var Highrisk = exports.Highrisk = function Highrisk(r) {
	  return __webpack_require__.e/* nsure */(1, function () {
	    return r(__webpack_require__(874));
	  });
	};

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(523);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'managementreport.phishingvulnerability',
	  path: '/managementreport/phishingvulnerability',
	  component: component.PhishingVulnerabilityTrend
	}, {
	  name: 'managementreport.awarenesstrendslook',
	  path: '/managementreport/awarenesstrendslook',
	  component: component.AwarenessTrendsLook
	}, {
	  name: 'managementreport.reportingtrend',
	  path: '/managementreport/reportingtrend',
	  component: component.ReportingTrend
	}, {
	  name: 'managementreport.weakest',
	  path: '/managementreport/weakest',
	  component: component.Weekest
	}, {
	  name: 'managementreport.strongest',
	  path: '/managementreport/strongest',
	  component: component.Strongest
	}, {
	  name: 'managementreport.departmentweakest',
	  path: '/managementreport/departmentweakest',
	  component: component.Deparmentweakest
	}, {
	  name: 'managementreport.highrisk',
	  path: '/managementreport/highrisk',
	  component: component.Highrisk
	}];

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
			value: true
	});
	
	
	var recipients = {
			index: function index(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(881));
					});
			},
			imports: function imports(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(880));
					});
			},
			edit: function edit(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(879));
					});
			},
			suppressionlist: function suppressionlist(r) {
					return __webpack_require__.e/* nsure */(4, function () {
							return r(__webpack_require__(883));
					});
			},
			suppression: {
					imports: function imports(r) {
							return __webpack_require__.e/* nsure */(4, function () {
									return r(__webpack_require__(882));
							});
					}
			}
	};
	
	exports.default = [{
			name: 'recipients',
			path: '/recipients',
			component: recipients.index
	}, {
			name: 'suppression',
			path: '/suppression',
			component: recipients.suppressionlist
	}, {
			name: 'recipients.imports',
			path: '/import/recipients',
			component: recipients.imports
	}, {
			name: 'recipients.suppression.imports',
			path: '/imports/suppression',
			component: recipients.suppression.imports
	}, {
			name: 'recipients.edit',
			path: '/recipients/:id',
			component: recipients.edit
	}];

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	                                value: true
	});
	var ReportingNew = exports.ReportingNew = function ReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(894));
	                                });
	};
	
	var Reporting = exports.Reporting = function Reporting(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(892));
	                                });
	};
	
	var ReportingsNew = exports.ReportingsNew = function ReportingsNew(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(893));
	                                });
	};
	
	var RepeatAffender = exports.RepeatAffender = function RepeatAffender(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(891));
	                                });
	};
	
	var campaignReporting = exports.campaignReporting = function campaignReporting(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(885));
	                                });
	};
	
	var campaignReportingNew = exports.campaignReportingNew = function campaignReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(886));
	                                });
	};
	
	var compareReportingNew = exports.compareReportingNew = function compareReportingNew(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(888));
	                                });
	};
	
	var recipientListing = exports.recipientListing = function recipientListing(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(890));
	                                });
	};
	
	var campaignDetailedReporting = exports.campaignDetailedReporting = function campaignDetailedReporting(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(884));
	                                });
	};
	
	var hcsa = exports.hcsa = function hcsa(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(889));
	                                });
	};
	var campaignReportingScenario = exports.campaignReportingScenario = function campaignReportingScenario(r) {
	                                return __webpack_require__.e/* nsure */(1, function () {
	                                                                return r(__webpack_require__(887));
	                                });
	};

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _components = __webpack_require__(526);
	
	var component = _interopRequireWildcard(_components);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = [{
	  name: 'report.campaignsnew',
	  path: '/report/campaignsnew',
	  component: component.ReportingNew,
	  meta: { requiresAuth: true }
	}, {
	  name: 'report.campaigns',
	  path: '/report/campaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allcampaigns',
	  path: '/report/allcampaigns',
	  component: component.ReportingsNew
	}, {
	  name: 'report.allannouncements',
	  path: '/report/allannouncements',
	  component: component.ReportingsNew
	}, {
	  name: 'report.campaigns.new',
	  path: '/report/campaigns/new',
	  component: component.ReportingsNew
	}, {
	  name: 'report.repeatAffender',
	  path: '/report/repeatAffender',
	  component: component.RepeatAffender
	}, {
	  name: 'report.campaignreporting',
	  path: '/report/campaigns/:id',
	
	  component: component.campaignReportingNew
	}, {
	  name: 'report.comparereporting',
	  path: '/report/compare/:id',
	
	  component: component.compareReportingNew
	}, {
	  name: 'report.campaignreporting.new',
	  path: '/report/campaigns/new/:id',
	  component: component.campaignReportingNew
	}, {
	  name: 'report.recipientlisting',
	
	  path: '/report/campaigns/:id/:type',
	  component: component.recipientListing
	}, {
	  name: 'report.detailedreporting',
	  path: '/report/detailed',
	  component: component.campaignDetailedReporting
	}, {
	  name: 'report.hcsa',
	  path: '/report/hcsa_hisp',
	  component: component.hcsa
	}, {
	  name: 'report.campaignreportingScenario',
	  path: '/scenarioreport/campaigns',
	  component: component.campaignReportingScenario
	}];

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(89);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _dashboard = __webpack_require__(148);
	
	var _company = __webpack_require__(144);
	
	var _bulk_campaign = __webpack_require__(142);
	
	var _recipient = __webpack_require__(151);
	
	var _campaign = __webpack_require__(143);
	
	var _report = __webpack_require__(152);
	
	var _setting = __webpack_require__(153);
	
	var _scenario = __webpack_require__(529);
	
	var _leaderboard = __webpack_require__(517);
	
	var _laggards = __webpack_require__(515);
	
	var _managementreport = __webpack_require__(522);
	
	var _lms = __webpack_require__(519);
	
	var _adn = __webpack_require__(496);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = [].concat((0, _toConsumableArray3.default)(_company.routes), (0, _toConsumableArray3.default)(_recipient.routes), (0, _toConsumableArray3.default)(_campaign.routes), (0, _toConsumableArray3.default)(_bulk_campaign.routes), (0, _toConsumableArray3.default)(_report.routes), (0, _toConsumableArray3.default)(_setting.routes), (0, _toConsumableArray3.default)(_scenario.routes), (0, _toConsumableArray3.default)(_laggards.routes), (0, _toConsumableArray3.default)(_dashboard.routes), (0, _toConsumableArray3.default)(_leaderboard.routes), (0, _toConsumableArray3.default)(_adn.routes), (0, _toConsumableArray3.default)(_managementreport.routes), (0, _toConsumableArray3.default)(_lms.routes));

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _routes = __webpack_require__(530);
	
	Object.defineProperty(exports, 'routes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_routes).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	
	var scenario = function scenario(r) {
	    return __webpack_require__.e/* nsure */(12, function () {
	        return r(__webpack_require__(896));
	    });
	};
	
	var manageScenario = {
	    index: function index(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(903));
	        });
	    },
	
	    description: function description(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(897));
	        });
	    },
	    email: function email(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(899));
	        });
	    },
	    sms: function sms(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(902));
	        });
	    },
	    landing: function landing(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(900));
	        });
	    },
	    education: function education(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(898));
	        });
	    },
	    review: function review(r) {
	        return __webpack_require__.e/* nsure */(5, function () {
	            return r(__webpack_require__(901));
	        });
	    }
	};
	
	exports.default = [{
	    name: 'scenario',
	    path: '/scenario',
	    component: scenario
	}, {
	    name: 'scenario.index',
	    path: '/scenario/create',
	    component: manageScenario.index,
	    redirect: { name: 'scenario.create' },
	    children: [{
	        name: 'scenario.description',
	        path: '/scenario/description',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.description',
	        path: '/scenario/description/:id',
	        component: manageScenario.description
	    }, {
	        name: 'scenario.edit.email',
	        path: '/scenario/email/:id',
	        component: manageScenario.email
	    }, {
	        name: 'scenario.edit.sms',
	        path: '/scenario/sms/:id',
	        component: manageScenario.sms
	    }, {
	        name: 'scenario.edit.landing',
	        path: '/scenario/landing/:id',
	        component: manageScenario.landing
	    }, {
	        name: 'scenario.edit.education',
	        path: '/scenario/education/:id',
	        component: manageScenario.education
	    }, {
	        name: 'scenario.edit.review',
	        path: '/scenario/review/:id',
	        component: manageScenario.review
	    }]
	}];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var general = function general(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(918));
	    });
	};
	var usermanagement = function usermanagement(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(928));
	    });
	};
	var directlearning = function directlearning(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(912));
	    });
	};
	var directlearning_recipient = function directlearning_recipient(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(913));
	    });
	};
	var campaign = function campaign(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(910));
	    });
	};
	var email = function email(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(917));
	    });
	};
	var landing = function landing(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(919));
	    });
	};
	var adform = function adform(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(906));
	    });
	};
	var listad = function listad(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(922));
	    });
	};
	var adlogs = function adlogs(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(907));
	    });
	};
	var alladlogs = function alladlogs(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(908));
	    });
	};
	var oopspage = function oopspage(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(920));
	    });
	};
	
	var trainingmail = function trainingmail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(315));
	    });
	};
	var dl_invitation_mail = function dl_invitation_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(914));
	    });
	};
	var dl_login_link_mail = function dl_login_link_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(915));
	    });
	};
	var dl_login_with_password_mail = function dl_login_with_password_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(916));
	    });
	};
	var security = function security(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(926));
	    });
	};
	var azure = function azure(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(909));
	    });
	};
	var books = function books(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(904));
	    });
	};
	
	var changepassword = function changepassword(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(911));
	    });
	};
	var bulkeducation = function bulkeducation(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(905));
	    });
	};
	var point_configure = function point_configure(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(924));
	    });
	};
	var reminder = function reminder(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(925));
	    });
	};
	var leaderboardsetting = function leaderboardsetting(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(921));
	    });
	};
	var welcome_mail = function welcome_mail(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(929));
	    });
	};
	var trainingmodule = function trainingmodule(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(927));
	    });
	};
	var master_landing = function master_landing(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(923));
	    });
	};
	var reminder_template = function reminder_template(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(315));
	    });
	};
	var throttling_sending_speed = function throttling_sending_speed(r) {
	    return __webpack_require__.e/* nsure */(0, function () {
	        return r(__webpack_require__(930));
	    });
	};
	exports.default = [{
	    name: 'general',
	    path: '/setting/general',
	    component: general
	}, {
	    name: 'throttling_sending_speed',
	    path: '/setting/throttling_sending_speed',
	    component: throttling_sending_speed
	}, {
	    name: 'master_landing',
	    path: '/setting/master_landing',
	    component: master_landing
	}, {
	    name: 'trainingmodule',
	    path: '/setting/trainingmodule',
	    component: trainingmodule
	}, {
	    name: 'leaderboardsetting',
	    path: '/setting/leaderboardsetting',
	    component: leaderboardsetting
	}, {
	    name: 'usermanagement',
	    path: '/setting/usermanagement',
	    component: usermanagement
	}, {
	    name: 'directlearning',
	    path: '/setting/directlearning',
	    component: directlearning
	}, {
	    name: 'directlearning_recipient',
	
	    path: '/setting/directlearning/:id/:type',
	    component: directlearning_recipient
	}, {
	    name: 'retest',
	    path: '/setting/campaign',
	    component: campaign
	}, {
	    name: 'email',
	    path: '/setting/email',
	    component: email
	}, {
	    name: 'landing',
	    path: '/setting/landing',
	    component: landing
	}, {
	    name: 'adform',
	    path: '/setting/adform',
	    component: adform
	}, {
	    name: 'listad',
	    path: '/setting/listad',
	    component: listad
	}, {
	    name: 'adlogs',
	    path: '/setting/adlogs/:id',
	    component: adlogs
	}, {
	    name: 'alladlogs',
	    path: '/setting/alladlogs',
	    component: alladlogs
	}, {
	    name: 'oopspage',
	    path: '/setting/oopspage',
	    component: oopspage
	}, {
	    name: 'trainingmail',
	    path: '/setting/trainingmail',
	    component: trainingmail
	}, {
	    name: 'dl_invitation_mail',
	    path: '/setting/dl_invitation_mail',
	    component: dl_invitation_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_link_mail',
	    path: '/setting/dl_login_link_mail',
	    component: dl_login_link_mail
	}, {
	    name: 'dl_login_with_password_mail',
	    path: '/setting/dl_login_with_password_mail',
	    component: dl_login_with_password_mail
	}, {
	    name: 'security',
	    path: '/setting/security',
	    component: security
	}, {
	    name: 'azure',
	    path: '/setting/azure',
	    component: azure
	}, {
	    name: 'books',
	    path: '/setting/books',
	    component: books
	}, {
	    name: 'changepassword',
	    path: '/setting/changepassword',
	    component: changepassword
	}, {
	    name: 'bulkeducation',
	    path: '/setting/bulkeducation',
	    component: bulkeducation
	}, {
	    name: 'point_configure',
	    path: '/setting/point_configure',
	    component: point_configure
	}, {
	    name: 'reminder',
	    path: '/setting/reminder',
	    component: reminder
	}, {
	    name: 'welcome_mail',
	    path: '/setting/welcome_mail',
	    component: welcome_mail
	}];

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(89);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(11);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(16);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _keys = __webpack_require__(41);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(7);
	
	var _auth = __webpack_require__(141);
	
	var _campaign = __webpack_require__(143);
	
	var _company = __webpack_require__(144);
	
	var _recipient = __webpack_require__(151);
	
	var _bulk_campaign = __webpack_require__(142);
	
	var _dashboard = __webpack_require__(148);
	
	var _report = __webpack_require__(152);
	
	var _setting = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vuex = { Auth: _auth.vuex, Company: _company.vuex };
	var keys = (0, _keys2.default)(vuex);
	
	var modules = keys.reduce(function (acc, key) {
	  return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, key, vuex[key].module));
	}, {});
	var plugins = keys.reduce(function (acc, key) {
	  return [].concat((0, _toConsumableArray3.default)(acc), [vuex[key].plugin]);
	}, []).filter(_lodash.isFunction);
	exports.default = { modules: modules, plugins: plugins };

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _moment2 = __webpack_require__(1);
	
	var _moment3 = _interopRequireDefault(_moment2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.mixin({
	    data: function data() {
	        return { loader: false };
	    },
	    methods: {
	        toggleLoader: function toggleLoader() {
	            this.loader = this.loader ? false : true;
	        },
	        moment: function moment() {
	            return _moment3.default.apply(undefined, arguments);
	        }
	    }
	});

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(6);
	
	var _alerts = __webpack_require__(932);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _vueSweetalert = __webpack_require__(1078);
	
	var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueSweetalert2.default);
	
	_vue2.default.mixin({
	    components: {
	        Alerts: _alerts2.default
	    },
	    computed: (0, _vuex.mapState)(['messages', 'fetching']),
	    methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['setMessage', 'resetMessages']), {
	        updateErrors: function updateErrors($response) {
	
	            var backendErrors = $response.response.data.errors;
	
	            for (var index in backendErrors) {
	                this.errors.add(index, backendErrors[index][0]);
	            }
	        }
	    })
	});

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(795);

/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperties = __webpack_require__(547);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	exports.default = install;
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bus = new _vue2.default();
	
	function install(Vue) {
	  (0, _defineProperties2.default)(Vue.prototype, {
	    $bus: {
	      get: function get() {
	        return bus;
	      }
	    }
	  });
	}

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(108);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(88);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lodash = __webpack_require__(7);
	
	var _services = __webpack_require__(103);
	
	var services = _interopRequireWildcard(_services);
	
	var _index = __webpack_require__(5);
	
	var _config = __webpack_require__(4);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (http, store, router) {
	    http.interceptors.request.use(function (config) {
	
	        if (!config.hideLoader) {
	            $('.pace').removeClass('pace-inactive');
	            $('.pace').addClass('pace-active');
	        }
	
	        store.dispatch('setFetching', { fetching: true });
	
	        return config;
	    }, function (error) {
	        return _promise2.default.reject(error);
	    }), http.interceptors.response.use(function (response) {
	        if (!response.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        return response;
	    }, function (error) {
	
	        if (!error.config.hideLoader) {
	            $('.pace').removeClass('pace-active');
	            $('.pace').addClass('pace-inactive');
	        }
	
	        var response = error.response;
	
	        if (response.status == 401) {
	            router.push({ name: 'lms.login' });
	        }
	
	        store.dispatch('resetMessages');
	
	        if (response.data.errors && (0, _typeof3.default)(response.data.errors) === 'object') {
	            store.dispatch('setMessage', { type: 'error', message: response.data.errors });
	        } else {
	            if (response.data.message) {
	                store.dispatch('setMessage', { type: 'warning', message: response.data.message });
	            }
	        }
	
	        store.dispatch('setFetching', { fetching: false });
	
	        return _promise2.default.reject(error);
	    });
	};

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _store = __webpack_require__(154);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var beforeEach = function beforeEach(to, from, next) {
	    var auth = to.meta.requiresAuth == undefined;
	    window.scrollTo(0, 0);
	
	    _store2.default.dispatch('resetMessages');
	
	    if (auth !== true) {
	        next();
	        return;
	    }
	
	    next();
	};
	
	exports.default = beforeEach;

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(89);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _auth = __webpack_require__(931);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _main = __webpack_require__(933);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _vueRouter = __webpack_require__(1076);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _beforeEach = __webpack_require__(538);
	
	var _beforeEach2 = _interopRequireDefault(_beforeEach);
	
	var _auth3 = __webpack_require__(141);
	
	var _app = __webpack_require__(106);
	
	var _c = __webpack_require__(506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	    name: 'lms/login',
	    path: '/lms/login',
	    component: _auth2.default,
	    meta: { requiresAuth: false },
	    children: [].concat((0, _toConsumableArray3.default)(_auth3.routes)),
	    redirect: { name: 'auth.login' }
	}, {
	    path: '/',
	    component: _main2.default,
	
	    meta: { requiresAuth: false },
	    children: [].concat((0, _toConsumableArray3.default)(_app.routes)),
	    redirect: { name: 'dashboard.index' }
	}, {
	    path: '/c',
	    component: _auth2.default,
	    meta: { requiresAuth: false },
	    children: [].concat((0, _toConsumableArray3.default)(_c.routes)),
	    redirect: { name: 'c.login' }
	}, {
	    name: 'catchall',
	    path: '*',
	    redirect: { name: 'dashboard.index' }
	}];
	
	var router = new _vueRouter2.default({
	    routes: routes,
	    linkActiveClass: 'active',
	    mode: 'history' });
	
	router.beforeEach(_beforeEach2.default);
	
	exports.default = router;

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _types = __webpack_require__(155);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
	    setFetching: function setFetching(_ref, obj) {
	        var commit = _ref.commit;
	
	        commit(TYPES.MAIN_SET_FETCHING, obj);
	    },
	    setMessage: function setMessage(_ref2, obj) {
	        var commit = _ref2.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, obj);
	    },
	    resetMessages: function resetMessages(_ref3) {
	        var commit = _ref3.commit;
	
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'success', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'error', message: {} });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'warning', message: '' });
	        commit(TYPES.MAIN_SET_MESSAGE, { type: 'validation', message: {} });
	    }
	};

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var isAuthPage = exports.isAuthPage = function isAuthPage(_ref) {
	    var route = _ref.route;
	
	    if (route.path.indexOf('/auth') !== -1) return true;
	
	    if (route.path.indexOf('/login') !== -1) return true;
	
	    if (route.path.indexOf('/register') !== -1) return true;
	
	    if (route.path.indexOf('/reset/') !== -1) return true;
	
	    if (route.path.indexOf('/verification') !== -1) return true;
	
	    if (route.path.indexOf('/lms/login') !== -1) return true;
	
	    if (route.path.indexOf('/lms/user_choice') !== -1) return true;
	
	    if (route.path.indexOf('/lms/user_license') !== -1) return true;
	
	    if (route.path.indexOf('/lms/user_entity_license') !== -1) return true;
	
	    if (route.path.indexOf('/lms/confirmation') !== -1) return true;
	
	    return false;
	};
	
	var shouldShowNavigation = exports.shouldShowNavigation = function shouldShowNavigation(_ref2, getters) {
	    var route = _ref2.route;
	    return route.path ? !getters.isAuthPage : false;
	};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(16);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _app = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _extends3.default)({}, _app.vuex.modules);

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(11);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _TYPES$MAIN_SET_FETCH;
	
	var _types = __webpack_require__(155);
	
	var TYPES = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_TYPES$MAIN_SET_FETCH = {}, (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_FETCHING, function (state, obj) {
	  state.fetching = obj.fetching;
	}), (0, _defineProperty3.default)(_TYPES$MAIN_SET_FETCH, TYPES.MAIN_SET_MESSAGE, function (state, obj) {
	  state.messages[obj.type] = obj.message;
	}), _TYPES$MAIN_SET_FETCH);

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(89);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _app = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [].concat((0, _toConsumableArray3.default)(_app.vuex.plugins));

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 783:
/***/ (function(module, exports) {

	module.exports = {"login":{"heading":{"login":"Login","forgot_password":"Forgot Password"},"humans_are_the_weakest_link":"Humans are the weakest link in Cyber Security.","now_make_it_the_strongest":"Now make it the strongest by deploying the HumanFirewall.","last_year_the_threat":"LAST YEAR THREAT VIA PHISHING ATTACKS INCREASED BY 400%!","email":"EMAIL","password":"PASSWORD","keep_me_logged_in":"Keep Me Logged In","forgot_password":"Forgot password?","error":"Error!","login":"Login","learning_login":"Request for Password","start_a_free_trial":"Start A Free Trial","email_address":"Email Address","please_check_your_email_password_reset":"Please check your email for instructions to reset your password.","reset_password":"Send Reset Instructions","back_to_login":"Back to Login","success":"Success: ","already_registered_with_us":"If you have already registered with us, you will receive an email with password reset instructions shortly.","your_registered_email_address":"Your registered email address","your_super_secret_password":"Your password","please_enter_your_email_here":"Please enter your email address"},"register":{"start_a_free_trial":"Register for Free Trial","register_secure_organization":"Register & Secure your organization against phishing.","your_first_name":"Your First name","your_last_name":"Your Last Name","your_job_title":"Your Job Title","your_organisation":"Organisation Name","number_of_employee":"Number of Employees","country":"Country","timezone":"Time Zone","lets_setup_your_account":"Let's setup your account credentials","email":"Email","mobile":"Mobile Number","emiratesid":"Emirates ID","password":"Password","re_type_password":"Confirm Password","i_agree":"By signing up, you agree to our ","terms":"Terms of Service ","and":"and ","policy":"Privacy Policy.","create_a_new_account":"Create a new account","if_you_already_account":"If you already have an account","sign_in":"Login here","sign_up":"Register here","please_enter_your_first_name_here":"Please enter your first name","please_enter_your_last_name_here":"Please enter your last name","please_enter_your_job_title_here":"Please enter your job title","your_company_or_brand_name":"Your Company or Brand name","you_can_also_enter_a_guessed_value":"Please enter the number of employees","your_residence_country":"Your country","please_enter_your_email_here":"Please enter your email","please_enter_your_password_here":"Please enter your password","Please_re_type_your_password_here":"Please re-enter your password","domain_already_verified":"This email is already verified and cannot be used again."},"verification":{"two_factor_authentication":"Two factor authentication","please_scan_this_qr_Code_image":"Please scan this QR Code in Google Authenticator App on your phone and enter the code generated.","please_enter_the_code_generated":"Please enter the code generated by Google Authenticator App.","you_can_download":"You can download the app for","ios_here":"iOS here","and_for":"and for ","android_here":"Android here","verification_code":"VERIFICATION CODE","activate_2fa_now":"Activate 2FA Now","skip_setup_2fa_later":"Skip & Setup 2FA Later","verify_proceed":"Verify & Proceed","please_enter_your_verification_code_here":"Please enter your verification code here.","something_went_wrong":"OOPS! It seems something is not right. Please try again.","blocked":"Email address has been blocked. Please contact administrator","refresh":"There seems to be a network issue. Request you to please refresh the page and try again.","verification_code_error":"Please enter correct verification code.","resend_verification_code":"Verification code has been re-sent successfully."},"forgotpassword":{"new_password":"New Password","confirm_password":"Confirm Password","submit":"Submit","cancel":"Cancel","please_enter_your_password_here":"Please enter your password","please_re_type_your_password here":"Please re-enter your password"}}

/***/ }),

/***/ 784:
/***/ (function(module, exports) {

	module.exports = {"import":{"name_not_entered":"Please enter file name.","file_not_selected":"Please select a file."},"description":{"title_1":"Title","title_2":"title","description":"Description","proceed":"PROCEED","example_header":"Example:","example":{"title_header":"Example: {campaign} Title","title":"Phishing Training- Level 1 users - Finance Team","description_header":"Example: {campaign} Description","description":"This {campaign} is meant to train users to recognise Phishing emails by using URL recognition, specifically identifying the primary domain.","note":"Giving a unique name to your {campaign} will help you identify which email you sent, to which set of users and what was the objective of the campaign. "},"copyright":"Copyright &copy;","humanFirewall":"HumanFirewall","tm":"TM","all_rights_reserved":"All rights reserved.","www_humanfirewall":"www.humanfirewall.io"},"education":{"you_can_skip":"You can Skip this Step.","skip_this_step":"Skip this step","learning":"Learning","super_hign_risk":"Super High Risks","basic_portlet_tools":"Basic Portlet tools include a slide toggle button ,refresh button  and a close button. All these are fully customizable and come with callback functions to integrate with your code. Clicking on the refresh button will simulate an AJAX call.","preview":"Preview","use_this":"Use This"},"email":{"please_select_any_recipient":"Please select Recipients for this {campaign}","please_select_atleast_recipient":"Please select at least one sheet.","sender_name":"Sender Name","email_subject":"Subject of the mail","sender":"Sender","email_domain":"Email Domain","please_select_a_domain_name":"Please select a domain name","personalise_subject_email":"You can personalise subject & email by adding custom tags","click_here_to_see_complete_list":"Click here to see the complete list of available tags","flag_email_as_urgent":"Flag email as urgent to get more attention from recipients","attachment_name":"Attachment Name","attachment_type":"Attachment Type","adobe_pdf":"Adobe PDF (.pdf)","microsoft_word":"Microsoft Word (.doc)","microsoft_excel":"Microsoft Excel (.xls)","preview_email_in_a_new_tab":"Preview email in a new tab","send_a_preview_email":"Send a test email","save_and_proceed":"SAVE AND PROCEED","send_test_email":"Send Test Email","name":"name","email":"Email","cancel":"Cancel","add_one_more_tester":"Add another email?","send_test_emails":"Send Test mail","select_recipients":"Select Recipients","a_make_believe_from_name":"Please enter sender's name","pick_a_domain_name_from_list":"Choose a domain name from the list","name_your_attachment_file":"Choose a name for your attachment ","email_sender_error":"Space is not allowed in sender","required":"Required"},"sms":{"from_name":"From Name","template":"Sms Template","preview_email_in_a_new_tab":"Preview SMS in a new tab"},"landing":{"you_can_skip_this_step":"You can skip this Step.","skip_this_step":"SKIP THIS STEP","specify_landing_url":"Specify Landing URL","subdomain":"Subdomain","domain_name":"Domain Name","please_select_any_domain_name":"Please select a Domain Name","subdirectory_file":"Subdirectory / File","landing_content":"Landing Content","edit_landing_page":"Edit landing page","preview_in_a_new_tab":"Preview in a new tab","save_and_proceed":"SAVE AND PROCEED","a_make_believe_subdomain_name":"Please enter a subdomain name","pick_a_domain_name_from_list":"Choose a domain name from the list","a_make_believe_sub_directory_name":"Please enter a sub directory name"},"schedule":{"send_on":"Send On :","send_between":"Send Between","to":"to","send_count_per_day":"Send Count (per day)","how_long_do_you_want_scenario_active":"How long do you want this campaign to stay active?","how_long_do_you_want_announcement_active":"How long do you want this Announcement to stay active?","explain":"(explain)","your_scenario_content_tracking_active":"Your campaign's content and tracking will be available as long as your campaign is active.","while_we_typically_suggest_keeping_scenarios":"While we recommend keeping campaigns active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","while_we_typically_suggest_keeping_announcement":"While we recommend keeping Announcement active for 5 to 7 days, we can accommodate as little as 1 day and as many as 30 days should your needs vary.","ok":"OK","please_select_one":"Please select one","total_number_of_recipients":"Total Number of recipients","i_agree_to_the":"I agree to the","terms_and_conditions":"terms & conditions","receive_daily_scenario":"Receive daily summary via email","receive_pdf_summary_report":"Receive PDF summary report","please_have_a_support1":"Please have a support professional review this scenario. NOTE: We will need atleast one full business day. We may need more time depending upon","please_have_a_support2":"your support plan! ","send_a_test_mail":"Send a Test Mail","send_a_test_campaign":"Send a Test Campaign","send_a_test_announcement":"Send a Test Announcement","email_summary":"E-mail Summary","send":"Send","action":"Action","now":"Now","schedule":"REVIEW & SCHEDULE","send_test_email":"Send Test Email","send_a_test_sms":"Send Test Message","name_1":"Name","email":"Email","sms":"Sms","phone":"Phone","name_2":"Name","cancel":"Cancel","add_one_more_tester":"Add another email?","add_one_more_sms_tester":"Add another SMS?","send_test_emails":"Send Test Email","send_test_sms":"Send Test SMS","auto_reminder_message":"Auto Reminder for mandatory training to be sent to people who"},"create":{"super_high_risk":"SUPER HIGH RISK","level":"Level","use_this":"Use This","preview":"Preview","filters_1":"FILTERS","filters_2":"Filters","method":"Method","data_entry":"Data Entry","attachment":"Attachment","click":"Click","announcement":"Announcement","levels":"Levels","level_1":"Level 1","level_2":"Level 2","level_3":"Level 3","level_4":"Level 4","level_5":"Level 5","apply":"Apply","close":"Close","motivator":"Motivator","general":"General","category":"Category","no_scenario":"No scenario found.","type":{"campaign_type":"Campaign Type","email":"Email","sms":"SMS"}},"index1":{"launch_a_new":" Add","prepare_your_organisation":"Create a new phishing attack simulation campaign ","prepare_your_organisation_announcement":"Create a new announcement ","pick_a_scenario":"Choose a Scenario","title_description":"Title & Description","email":"Email","sms":"Sms","landing_page":"Landing Page","education":"Education","schedule_publish":"Schedule","cancel":"Cancel"},"index2":{"back_to_campaigns":"Back to Campaigns","back_to_announcements":"Back to Announcements","manage":"Manage","no_recipient_added":"You have not added a recipient yet:","add_recipients":"Add Recipients","launch_a_new":"Launch A New Campaign","launch_a_new_announcement":"Launch A New Announcement","draft":"Draft","you_have":"You have","ending_soon":"ending soon","launched_on":"STARTS","launched_for":"ENDS","title":"Title","description":"Description","email_sent":"Email Sent","sent":"Sent","channel":"Channel","opened":"Opened","clicked":"Clicked","submitted":"Submitted","compromised":"Compromised","acknowledged":"Acknowledged","trained":"Trained","level":"Level","status":"Status","edit":"Edit","no":"No","launched_yet":"launched yet.","found":"Found.","live":"Live","past":"Past","you_have_launched":"You have launched","in_total":"in total","recipient_count":"Recipients","before_loading":"Please wait while your campaigns load","before_loading_announcement":"Please wait while your announcements load"},"test_mail":{"error_in_test_mail":"Error in sending test mail.","error_in_test_sms":"Error in sending test message.","success_in_test_mail":"Test mail sent successfully.","success_in_test_sms":"Test message sent successfully."},"bulk_campaign":{"error_in_date_conflict":"Campaign dates are confliciting.Please check and update dates.","error_early_schedule":"You cannot schedule campaigns within 1 hours of current time. Please reschedule the campaign","only_announcement_message":"You can select only announcements"},"scenario":{"before_loading":"Please wait while your scenarios load","file_select_error":"Please select thumbnail image."}}

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

	module.exports = {"index":{"add":"Add","add_new_domain":"Add New Domain","action":"Action","create_new_domain":"Please enter the name of your domain.","click_on_download_button":"Download the TXT file by clicking on the download button. You can upload the file using your preferred FTP client.","click_on_verify_button":"Then click on the verify button","close":"Close","domain_name":"Domain Name","domain_link":"Domain URL","domain":"Domain","download":"Download","domains_1":"Domains","domains_2":"domains.","domain_verification_steps":"Domain Verification Steps","enter_your_domain":"Enter your Domain details.","entries":"entries","home":"Home","new":"Add New","of":"of","step_1":"Step:1","step_2":"Step:2","step_3":"Step:3","showing":"Showing","sr_no":"Sr. No.","you_have_added":"You have added","verification_status":"Verification Status","1_to":"1 to","name_of_your_domain":"Domain Name","example_www_yourdomain_com":"Example: www.yourdomain.com"}}

/***/ }),

/***/ 786:
/***/ (function(module, exports) {

	module.exports = {"leaderboard":{"add_recipient_1st":"add recipient","department":"Department","designation":"Designation","email":"Email","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","name":"Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","leader_1":"Leaderboard","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"Sr.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before running Phishing, Simulation or Announcements.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","total_score":"Total Score","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Add","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date","clicked":"Clicked","report":"Report","trained":"Trained","compromised":"Compromised","total":"Total"}}

/***/ }),

/***/ 787:
/***/ (function(module, exports) {

	module.exports = {"recipient":{"add_recipient_1st":"add recipient","department":"Department","designation":"Designation","email":"Email","filter_by_loction":"Filter by loction","filter_by_department":"Filter by Department","filter_by_designation":"Filter by Designation","first_name":"First Name","import_recipients":"Import Recipients","last_name":"Last Name","location":"Location","no_recipient":"No Recipient","recipients_1":"Recipients","recipients_2":"recipients","recipient":"recipient","registered_with_us":"registered with us.","s_no":"S.no","to_run_phishing_before_text":"Please","to_run_phishing_after_text":"before running Phishing, Simulation or Announcements.","you_have":"You have","search":"Search","by_location":"By Location","by_department":"By Department","by_designation":"By Designation","error_on_location":"Please enter your location","error_on_designation":"Please enter your designation","error_on_department":"Please enter your department","error_on_sheet":"Please enter a name for the sheet","action":"Action","domain_verify":"Please verify your domain before uploading the recipient list."},"import":{"add":"Next","action":"Action","close":"Close","download":"Download","download_sample_sheet":"Download sample sheet","imported_sheets":"View Recipents Lists","import_new_sheet":"Import New Sheet","imported_by":"Imported By","imported_on":"Imported On","in_total":"in total","import_sheet":"Import Sheet","import_your_sheet":"Import your sheet","name":"name","no_sheet":"no sheet","please_download_sample_sheet":"Please download the sample sheet before uploading. Please ensure that you do not remove the headers.","recipients_count":"Add Count","recipients_update_count":"Update Count","sheet":"sheet","sheets":"sheets","sheet_name":"Sheet Name","status":"Status","you_have_imported":"You have imported","name_of_sheet":"Name of sheet"},"edit":{"action":"Action","campaign_name":"Campaign Name","cancel":"Cancel","designation":"Designation","department":"Department","edit":"Edit","email_id":"Email ID","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","edit_user_information":"Edit User Information","first_name":"First Name","filter_by_date":"Filter by date","id":"Id","location":"Location","last_name":"Last Name","phone_no":"Phone No.","report_list":"Report List","submit":"Submit","time_in_gmt":"Time","no_results":"No results found.","search":"Search","pick_a_date":"Pick a date"}}

/***/ }),

/***/ 788:
/***/ (function(module, exports) {

	module.exports = {"campaignreporting":{"campaigns":"Campaigns","filter_by_date":"Filter by date","export":"Export","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","date":"Date","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","pick_a_date":"Select a date"},"recipientlisting":{"export":"Export","filter_by_date":"Filter by date","export_as_pdf":"Export as PDF","export_as_excel":"Export as Excel","export_as_csv":"Export as CSV","id":"Id","recipient_name":"Recipient Name","recipient_email":"Recipient Email","department":"Department","location":"Location","action":"Action","view_log":"View Log","search":"Search","pick_a_date":"Select a date"},"repeataffender":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting.","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","open":"Open","click":"Click","status":"Status","search":"Search","select_campaign":"Select Campaign"},"reporting":{"campaigns_report":"Campaigns Report","campaign_type":"Campaign Type","camapigns":"Camapigns","repeat_offenders":"Repeat Offenders","not_tested_yet":"Not Tested Yet","hi_3":"hi 3","campaigns_reporting":"Campaigns Reporting..","filter_by_status":"Filter by Status","sr_no":"Sr. No","title_description":"Title / Description","started":"Started","sent":"Sent","open":"Open","click":"Click","compromise":"Compromise","learning":"Learning","status":"Status","search":"Search","select_campaign":"Select Campaign"}}

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(359)
	
	/* template */
	var __vue_template__ = __webpack_require__(1008)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(490)
	
	/* template */
	var __vue_template__ = __webpack_require__(1043)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(732)
	
	/* script */
	__vue_exports__ = __webpack_require__(491)
	
	/* template */
	var __vue_template__ = __webpack_require__(1005)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53c7772c"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(492)
	
	/* template */
	var __vue_template__ = __webpack_require__(1015)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(493)
	
	/* template */
	var __vue_template__ = __webpack_require__(1030)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(494)
	
	/* template */
	var __vue_template__ = __webpack_require__(1070)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "alerts"
	  }, [_c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasSuccessMessage),
	      expression: "hasSuccessMessage"
	    }],
	    attrs: {
	      "title": _vm.messages.success,
	      "type": "success",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('success')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasErrorMessages),
	      expression: "hasErrorMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedErrorMessage,
	      "type": "error",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('error')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasValidationMessages),
	      expression: "hasValidationMessages"
	    }],
	    attrs: {
	      "title": _vm.formatedValidationMessage,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('validation')
	      }
	    }
	  }), _vm._v(" "), _c('el-alert', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.hasWarningMessages),
	      expression: "hasWarningMessages"
	    }],
	    attrs: {
	      "title": _vm.messages.warning,
	      "type": "warning",
	      "show-icon": ""
	    },
	    on: {
	      "close": function($event) {
	        _vm.dismiss('validation')
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view', {
	    key: _vm.$route.fullPath
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.shouldShowNavigation) ? _c('side-bar') : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "page-container"
	  }, [(_vm.shouldShowNavigation) ? _c('nav-bar') : _vm._e(), _vm._v(" "), _c('router-view', {
	    key: _vm.$route.fullPath
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1030:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header"
	  }, [_c('a', {
	    staticClass: "btn-link toggle-sidebar d-lg-none pg-icon btn-icon-link",
	    attrs: {
	      "href": "#",
	      "data-toggle": "sidebar"
	    }
	  }, [_vm._v("\n          menu")]), _vm._v(" "), _c('div', {
	    staticClass: "in_mobile"
	  }, [_c('div', {
	    staticClass: "brand inline d-none d-lg-block d-xl-block"
	  }, [(_vm.company_logo) ? _c('img', {
	    staticClass: "logo_c",
	    staticStyle: {
	      "height": "60px"
	    },
	    attrs: {
	      "src": _vm.company_logo,
	      "alt": "logo",
	      "data-src": _vm.company_logo,
	      "data-src-retina": _vm.company_logo
	    }
	  }) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "d-flex align-items-center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "dropdown pull-right d-lg-block d-none"
	  }, [_c('button', {
	    staticClass: "profile-dropdown-toggle logindetail_p",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "aria-label": "profile dropdown"
	    }
	  }, [_c('div', {
	    staticClass: "logindetail"
	  }, [_c('span', [_vm._v(_vm._s(_vm.user.company))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_c('a', {
	    staticClass: "pull-left",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logoutUser()
	      }
	    }
	  }, [_vm._v("Logout")]), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-divider"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "theme_change  btn-icon-link",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sun"
	  }), _c('i', {
	    staticClass: "far fa-moon"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "thumbnail-wrapper d32 circular inline"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/assets/img/user.svg",
	      "alt": "",
	      "data-src": "/static/assets/img/user.svg",
	      "data-src-retina": "/static/assets/img/user.svg",
	      "width": "32",
	      "height": "32"
	    }
	  })])
	}]}

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "page-sidebar",
	    attrs: {
	      "data-pages": "sidebar"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-menu"
	  }, [_c('ul', {
	    staticClass: "menu-items"
	  }, [_c('li', {
	    staticClass: "open active m-t-30"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "sub-menu"
	  }, [_c('li', {}, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.courses2'
	      }
	    }
	  }, [_vm._v("Courses")]), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.reports'
	      }
	    }
	  }, [_vm._v("Reports")]), _vm._v(" "), _vm._m(4)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.setting'
	      }
	    }
	  }, [_vm._v("Settings")]), _vm._v(" "), _vm._m(5)], 1), _vm._v(" "), _c('li', {}, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'lms.emaillogs'
	      }
	    }
	  }, [_vm._v("Sent mails")]), _vm._v(" "), _vm._m(6)], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sidebar-header"
	  }, [_c('img', {
	    staticClass: "brand",
	    attrs: {
	      "src": "/static/img/logo-white.svg",
	      "alt": "logo",
	      "data-src": "/static/img/logo-white.svg",
	      "data-src-retina": "/static/img/logo-white.svg",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sidebar-header-controls"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "javascript:;"
	    }
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v("LMS")]), _vm._v(" "), _c('span', {
	    staticClass: " open  arrow"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-book-reader custom_reader"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-book"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-file-alt"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "fas fa-cog"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "icon-thumbnail"
	  }, [_c('i', {
	    staticClass: "far fa-envelope"
	  })])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.b74daf0b5f2245494bfc.js